import { GenerateLocationDescription } from 'domain/usecases/ai/generate-location-description';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGenerateLocationDescription
  extends BaseHttpService<GenerateLocationDescription.Model>
  implements GenerateLocationDescription
{
  async generateDescription(params: GenerateLocationDescription.Params): Promise<GenerateLocationDescription.Model> {
    return await this.request('get');
  }
}
